import React from 'react';
import ValidationComponent from '../components/container/validation';

const Validation = () => {
    return (
        <div className='h-screen'>
            <ValidationComponent />
        </div>
    );
}

export default Validation;
